import axios from 'axios';
import ENDPOINT from './../../endpoints';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import {add0StringToNumberLessThan10} from '@/util/dateTimeUtils';
import {
  REQUEST_INVENTORY_FILTER_DATA_MODEL,
  REQUEST_INVENTORY_LIST_MODEL
} from '@/constants/reserved/inventoryConstants';
import {isFailResponse, addLoginUserInfoToPayload} from '@/util/apiUtils';
import store from '@/store';

export function fetchFilterData(payload) {
  let fetchFilterDataPayload = {
    ...REQUEST_INVENTORY_FILTER_DATA_MODEL
  };

  fetchFilterDataPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.RESERVED.INVENTORY.FILTER_DATA, fetchFilterDataPayload)
      .then((response) => {

        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || []);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchInventoryList(payload) {
  let fetchUsageListPayload = {
    ...REQUEST_INVENTORY_LIST_MODEL
  };

  fetchUsageListPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.RESERVED.INVENTORY.INVENTORY_LIST, fetchUsageListPayload)
      .then((response) => {

        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}




// WEBPACK FOOTER //
// ./src/api/reserved/inventory/index.js